module.exports = __webpack_public_path__ + "img/child-pool-settings.6214967a.svg";